import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { CustomPlanRedirect } from "./CustomPlanRedirect";

const ContractsPage = lazy(() => import("@/pages/contracts/ContractsPage"));
const ContractCreatePage = lazy(() => import("@/pages/contracts/ContractCreatePage"));
const ContractEditPage = lazy(() => import("@/pages/contracts/ContractEditPage"));
const ContractViewPage = lazy(() => import("@/pages/contracts/ContractViewPage"));
const ContractTimelinePage = lazy(() => import("@/pages/contracts/ContractTimelinePage"));
const QuickAddContractPage = lazy(() => import("@/pages/contracts/QuickAddContractPage"));
const ContractExtractionPage = lazy(() => import("@/pages/contracts/ContractExtractionPage"));
const DuplicateDetectionPage = lazy(() => import("@/pages/contracts/DuplicateDetectionPage"));
const ContractDocumentEditPage = lazy(() => import("@/pages/contracts/ContractDocumentEditPage"));
const ContractImportPage = lazy(() => import("@/pages/contracts/ContractImportPage"));

export function ContractRoutes() {
  return (
    <>
      <Route path="/contracts" element={<ProtectedRoute><CustomPlanRedirect><ContractsPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/new" element={<ProtectedRoute><CustomPlanRedirect><ContractCreatePage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/quick-add" element={<ProtectedRoute><CustomPlanRedirect><QuickAddContractPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/extract" element={<ProtectedRoute><CustomPlanRedirect><ContractExtractionPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/import" element={<ProtectedRoute><CustomPlanRedirect><ContractImportPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/duplicates" element={<ProtectedRoute><CustomPlanRedirect><DuplicateDetectionPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/:id/edit" element={<ProtectedRoute><CustomPlanRedirect><ContractEditPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/:id" element={<ProtectedRoute><CustomPlanRedirect><ContractViewPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/:id/timeline" element={<ProtectedRoute><CustomPlanRedirect><ContractTimelinePage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contracts/:id/documents/:documentId" element={<ProtectedRoute><CustomPlanRedirect><ContractDocumentEditPage /></CustomPlanRedirect></ProtectedRoute>} />
    </>
  );
}
